<template>
    <v-card v-if="order">
        <v-toolbar
            color="primary"
            dark
            flat
        >
            <v-toolbar-title class="text-capitalize">
                {{ error ? 'Error processing payment via Mono' : 'Manual Bank Transfer' }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
                :to="{ name: 'transfers' }"
                icon
                dark
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
            <v-alert
                v-if="error"
                dense
                outlined
                type="error"
            >
                There was an error processing your payment with your card
            </v-alert>
            <p
                v-if="error"
                class="mb-0"
            >
                Let us retry via bank transfer
            </p>
            <p>
                Send
                <strong class="button">
                    {{ (order.poster_amount + order.poster_fee) | currency }} {{ order.poster_currency }}
                </strong>
                to
            </p>
            <v-sheet
                class="d-flex"
                color="grey lighten-3"
            >
                <v-col>
                    <p class="mb-0">
                        {{ bankName }}
                    </p>
                    <p class="mb-0">
                        {{ accountNumber }}
                    </p>
                    <p class="mb-0">
                        Kaoshi
                    </p>
                </v-col>
            </v-sheet>
        </v-card-text>

        <v-alert
            color="warning"
            class="body-2 px-6 mt-3 mx-6"
            text
            dense
        >
            Note: Payment must be made from a bank account bearing your name.
            Payment from a bank account not bearing your name will not be accepted.
        </v-alert>

        <v-card-actions class="text-center pb-6">
            <v-btn
                class="px-3"
                text
                color="red darken-2"
                large
                @click="$emit('cancel')"
            >
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn
                class="px-3 paid-button"
                color="primary"
                dark
                depressed
                large
                @click="$emit('verify', true)"
            >
                I have made payment
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        order: Object,
        error: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            bankName: process.env.MIX_KAOSHI_BANK_NAME || 'Wema Bank PLC',
            accountNumber: process.env.MIX_KAOSHI_ACCOUNT_NUMBER || '7822138514',
        };
    },
};
</script>

<style lang="scss" scoped>
.paid-button {
    animation: shadow-pulse 1s infinite;
    text-transform: none;
}

@keyframes shadow-pulse
{
    0% { transform: scale(1); }
    30% { transform: scale(1); }
    40% { transform: scale(1.08); }
    50% { transform: scale(1); }
    60% { transform: scale(1); }
    70% { transform: scale(1.05); }
    80% { transform: scale(1); }
    100% { transform: scale(1); }
}
</style>
